import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.myinterviews');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-myinterviews',
template: templateSource || '',
    styles: [``],
})
export class PageMyinterviewsComponent implements OnInit {
    public loading: boolean = true;
    public detailLoading: boolean = false;
    public saving: boolean = false;
    public submitting: boolean = false;
    public generatingQuestionDrafts: boolean = false;
    public questionDraftActionId: string = "";
    public payload: any = null;
    public uiPolicy: any = {
        solo_admin_mode: true,
        solo_admin_applies: false
    };
    public items: any[] = [];
    public accessError: string = "";
    public selectedAssignmentId: string = "";
    public selected: any = null;
    public evaluation: any = null;
    public questionDrafts: any[] = [];
    public questionDraftSummary: any = null;
    public questionDraftMessage: string = "";
    public filters: any = {
        round_type: "",
        status: ""
    };
    public form: any = {
        rating: "",
        recommendation: "",
        summary_note: ""
    };
    public questionRows: any[] = [
        { question: "", answer: "", note: "" }
    ];

    constructor(@Inject( Service) public service: Service) {}

    public async ngOnInit() {
        await this.service.init();
        await this.service.auth.allow("/access");
        await this.load();
    }

    public async load() {
        this.loading = true;
        this.accessError = "";
        await this.service.render();

        const { code, data, message } = await wiz.call("get_my_assignments", {
            round_type: this.filters.round_type,
            status: this.filters.status
        });
        if (code === 200) {
            this.payload = data;
            this.updateUiPolicy(data);
            this.items = data?.items || [];
            if (this.selectedAssignmentId && !this.items.find((item: any) => item.assignment_id === this.selectedAssignmentId)) {
                this.clearSelection();
            }
            if (!this.selectedAssignmentId && this.items.length) {
                await this.selectAssignment(this.items[0], false);
            }
        } else {
            this.payload = null;
            this.items = [];
            this.clearSelection();
            this.accessError = this.myInterviewsErrorMessage(code, message || data?.message);
        }

        this.loading = false;
        await this.service.render();
    }

    public async applyFilters() {
        this.selectedAssignmentId = "";
        this.clearSelection();
        await this.load();
    }

    public async resetFilters() {
        this.filters = { round_type: "", status: "" };
        this.selectedAssignmentId = "";
        this.clearSelection();
        await this.load();
    }

    public async selectAssignment(item: any, render: boolean = true) {
        if (!item?.assignment_id) return;
        this.selectedAssignmentId = item.assignment_id;
        this.detailLoading = true;
        if (render) await this.service.render();

        const { code, data, message } = await wiz.call("get_evaluation", {
            assignment_id: item.assignment_id
        });
        this.detailLoading = false;

        if (code === 200) {
            this.selected = data?.assignment || item;
            this.updateUiPolicy(data);
            this.evaluation = data?.evaluation || null;
            this.questionDrafts = data?.question_drafts || [];
            this.questionDraftSummary = data?.question_draft_summary || null;
            this.questionDraftMessage = "";
            this.seedForm();
        } else {
            this.clearSelection();
            await this.service.modal.error(message || "면접 평가 조회 중 오류가 발생했습니다.");
        }
        if (render) await this.service.render();
    }

    public seedForm() {
        this.form = {
            rating: this.evaluation?.rating ?? "",
            recommendation: this.evaluation?.recommendation || "",
            summary_note: this.evaluation?.summary_note || ""
        };
        const rows = this.evaluation?.question_rows || [];
        this.questionRows = rows.length ? rows.map((row: any) => ({
            question: row.question || "",
            answer: row.answer || "",
            note: row.note || ""
        })) : [{ question: "", answer: "", note: "" }];
    }

    public clearSelection() {
        this.selected = null;
        this.evaluation = null;
        this.questionDrafts = [];
        this.questionDraftSummary = null;
        this.questionDraftMessage = "";
        this.form = { rating: "", recommendation: "", summary_note: "" };
        this.questionRows = [{ question: "", answer: "", note: "" }];
    }

    public addQuestionRow() {
        this.questionRows.push({ question: "", answer: "", note: "" });
    }

    public removeQuestionRow(index: number) {
        if (this.questionRows.length <= 1) {
            this.questionRows = [{ question: "", answer: "", note: "" }];
            return;
        }
        this.questionRows.splice(index, 1);
    }

    public canEditEvaluation() {
        return !!this.evaluation?.can_edit && !this.evaluation?.submitted;
    }

    public canSubmitEvaluation() {
        return !!this.evaluation?.can_submit && !this.evaluation?.submitted;
    }

    public visibleQuestionDrafts() {
        return (this.questionDrafts || []).filter((draft: any) => {
            return ["DRAFT", "REVIEWED"].includes(draft.status) && !draft.prohibited;
        });
    }

    public canUseQuestionDrafts() {
        return !!this.evaluation?.can_use_question_drafts && !this.evaluation?.submitted;
    }

    public questionDraftButtonLabel() {
        if (!this.canUseQuestionDrafts()) return "권한 필요";
        return this.generatingQuestionDrafts ? "생성 중" : "질문 초안 생성";
    }

    public updateUiPolicy(data: any) {
        const policy = data?.ui_policy || data?.permissions?.ui_policy || null;
        if (policy) this.uiPolicy = { ...this.uiPolicy, ...policy };
    }

    public soloAdminMode() {
        return !!this.uiPolicy?.solo_admin_mode && !!this.uiPolicy?.solo_admin_applies;
    }

    public compactStatusLabel(label: any) {
        const text = String(label || "").trim();
        if (!text) return "";
        if (text.includes("권한")) return text;
        if (/심사위원 입력 필요|정성 대기|담당자 확인 필요|관리자 확인 필요|수동검토 필요/.test(text)) return "확인 필요";
        if (text.includes("자동 산정 초안")) return "초안";
        return text;
    }

    public evaluationStatusLabel(item: any) {
        const label = item?.evaluation_status_label || item?.status_label || item?.evaluation_status || "";
        return this.soloAdminMode() ? this.compactStatusLabel(label) : label;
    }

    public async generateQuestionDrafts() {
        if (!this.selected?.interview_round_id || this.generatingQuestionDrafts) return;
        if (!this.canUseQuestionDrafts()) {
            await this.service.modal.error("질문 초안 생성 권한이 필요합니다.");
            return;
        }

        this.generatingQuestionDrafts = true;
        this.questionDraftMessage = "";
        await this.service.render();

        const { code, data, message } = await wiz.call("generate_question_drafts", {
            round_id: this.selected.interview_round_id
        });
        this.generatingQuestionDrafts = false;

        if (code === 200 && data?.ok !== false) {
            this.updateUiPolicy(data);
            this.questionDrafts = data?.drafts || [];
            this.questionDraftSummary = data?.question_draft_summary || null;
            this.questionDraftMessage = data?.safe_message || this.questionDraftResultMessage(data);
            await this.service.render();
            return;
        }

        await this.service.modal.error(this.safeErrorMessage(code, message || data?.message, "질문 초안 생성 중 오류가 발생했습니다."));
        await this.service.render();
    }

    public async useQuestionDraft(draft: any) {
        if (!draft?.id || this.questionDraftActionId) return;
        if (!this.canUseQuestionDrafts()) {
            await this.service.modal.error("질문 초안 사용 권한이 필요합니다.");
            return;
        }

        this.questionDraftActionId = draft.id;
        await this.service.render();

        const { code, data, message } = await wiz.call("use_question_draft", {
            draft_id: draft.id
        });
        this.questionDraftActionId = "";

        if (code === 200 && data?.ok !== false) {
            this.updateUiPolicy(data);
            this.questionRows.push({
                question: draft.question_text || data?.draft?.question_text || "",
                answer: "",
                note: ""
            });
            this.questionDrafts = this.questionDrafts.map((item: any) => {
                return item.id === draft.id ? { ...item, status: "USED", status_label: "사용됨" } : item;
            });
            this.questionDraftSummary = data?.question_draft_summary || this.questionDraftSummary;
            this.questionDraftMessage = "질문 초안을 입력 행에 추가했습니다. 점수와 추천은 직접 입력해야 합니다.";
            await this.service.render();
            return;
        }

        await this.service.modal.error(this.safeErrorMessage(code, message || data?.message, "질문 초안 사용 중 오류가 발생했습니다."));
        await this.service.render();
    }

    public questionDraftResultMessage(data: any) {
        const created = Number(data?.created_count || 0);
        const reused = Number(data?.reused_count || 0);
        const filtered = Number(data?.filtered_count || 0);
        const parts = [`새로 생성 ${created}건`, `기존 유지 ${reused}건`];
        if (filtered) parts.push(`필터링 ${filtered}건`);
        return `질문 초안이 준비되었습니다. ${parts.join(" · ")}`;
    }

    public async dismissQuestionDraft(draft: any) {
        if (!draft?.id || this.questionDraftActionId) return;

        this.questionDraftActionId = draft.id;
        await this.service.render();

        const { code, data, message } = await wiz.call("dismiss_question_draft", {
            draft_id: draft.id
        });
        this.questionDraftActionId = "";

        if (code === 200 && data?.ok !== false) {
            this.updateUiPolicy(data);
            this.questionDrafts = this.questionDrafts.map((item: any) => {
                return item.id === draft.id ? { ...item, status: "DISMISSED", status_label: "숨김" } : item;
            });
            this.questionDraftSummary = data?.question_draft_summary || this.questionDraftSummary;
            this.questionDraftMessage = "질문 초안을 숨김 처리했습니다.";
            await this.service.render();
            return;
        }

        await this.service.modal.error(this.safeErrorMessage(code, message || data?.message, "질문 초안 숨김 중 오류가 발생했습니다."));
        await this.service.render();
    }

    public async saveDraft() {
        if (!this.selectedAssignmentId || this.saving) return;
        if (!this.canEditEvaluation()) {
            await this.service.modal.error("제출 후에는 수정할 수 없습니다.");
            return;
        }

        this.saving = true;
        await this.service.render();

        const { code, data, message } = await wiz.call("save_draft", this.evaluationPayload());
        this.saving = false;

        if (code === 200 && data?.ok !== false) {
            this.updateUiPolicy(data);
            this.evaluation = data?.evaluation;
            this.selected = data?.assignment || this.selected;
            this.seedForm();
            await this.load();
            return;
        }

        await this.service.modal.error(this.safeErrorMessage(code, message || data?.message, "면접 평가 임시저장 중 오류가 발생했습니다."));
        await this.service.render();
    }

    public async submitEvaluation() {
        if (!this.selectedAssignmentId || this.submitting) return;
        if (!this.canSubmitEvaluation()) {
            await this.service.modal.error("제출 후에는 수정할 수 없습니다.");
            return;
        }
        if (this.form.rating === "" || this.form.rating === null || this.form.rating === undefined) {
            await this.service.modal.error("제출하려면 rating 입력이 필요합니다.");
            return;
        }
        if (!this.form.recommendation) {
            await this.service.modal.error("제출하려면 추천 의견이 필요합니다.");
            return;
        }

        this.submitting = true;
        await this.service.render();

        const { code, data, message } = await wiz.call("submit_evaluation", this.evaluationPayload());
        this.submitting = false;

        if (code === 200 && data?.ok !== false) {
            this.updateUiPolicy(data);
            this.evaluation = data?.evaluation;
            this.selected = data?.assignment || this.selected;
            this.seedForm();
            await this.load();
            return;
        }

        await this.service.modal.error(this.safeErrorMessage(code, message || data?.message, "면접 평가 제출 중 오류가 발생했습니다."));
        await this.service.render();
    }

    public evaluationPayload() {
        return {
            assignment_id: this.selectedAssignmentId,
            rating: this.form.rating,
            recommendation: this.form.recommendation || "",
            summary_note: this.form.summary_note || "",
            question_rows: this.questionRows.map((row: any) => ({
                question: row.question || "",
                answer: row.answer || "",
                note: row.note || ""
            }))
        };
    }

    public roundTypeOptions() {
        return [{ key: "", label: "전체" }, ...(this.payload?.round_types || [])];
    }

    public evaluationStatusOptions() {
        return [
            { key: "", label: "전체" },
            ...(this.payload?.evaluation_statuses || [])
        ];
    }

    public recommendationOptions() {
        return [{ key: "", label: "선택" }, ...(this.payload?.recommendations || [])];
    }

    public ratingOptions() {
        return [
            { value: "", label: "선택" },
            { value: 1, label: "1점" },
            { value: 2, label: "2점" },
            { value: 3, label: "3점" },
            { value: 4, label: "4점" },
            { value: 5, label: "5점" }
        ];
    }

    public safeErrorMessage(code: number, message: string, fallback: string) {
        if (code === 403) return "본인에게 배정된 면접만 조회하거나 입력할 수 있습니다.";
        if (code === 409) return "제출 후에는 수정할 수 없습니다.";
        const text = String(message || "").trim();
        if (!text || /Traceback|File \"|\/opt\/|storage_key|file_path|<html/i.test(text)) return fallback;
        return text.length > 140 ? `${text.slice(0, 140).trim()}...` : text;
    }

    public myInterviewsErrorMessage(code: number, message: string) {
        if (code === 403) return "내 면접 조회 권한이 필요합니다.";
        return this.safeErrorMessage(code, message, "내 면접 목록 조회 중 오류가 발생했습니다.");
    }

    public badgeClass(status: string) {
        status = status || "";
        if (status === "SUBMITTED" || status === "COMPLETED" || status === "SCHEDULED") return "bg-emerald-50 text-emerald-700 border border-emerald-200";
        if (status === "DRAFT" || status === "ASSIGNED" || status === "IN_PROGRESS") return "bg-amber-50 text-amber-700 border border-amber-200";
        if (status === "CANCELED" || status === "DECLINED" || status === "NOT_RECOMMEND") return "bg-rose-50 text-rose-700 border border-rose-200";
        return "bg-zinc-50 text-zinc-600 border border-zinc-200";
    }
}

export default PageMyinterviewsComponent;